import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PLAID_KEY, APP_ENV } from '@config';
import Actions, { thunks } from '@redux/app';
import { PaymentMethodsForm } from '@components/paymentMethodsForm';
import { Loader } from '@components/common';
import { isEqual, pick } from 'lodash';

class AddPaymentMethod extends Component {
	constructor(props) {
		super(props);

		const { USStates, getUSStates } = props;

		if (USStates.length === 0) getUSStates();
	}

	shouldComponentUpdate = ({ USStates, loadingUSStates, loadingAddPaymentMethod }) => {
		const lastProps = this.props;

		return (
			!isEqual(lastProps.USStates, USStates)
			|| !isEqual(lastProps.loadingUSStates, loadingUSStates)
			|| !isEqual(lastProps.loadingAddPaymentMethod, loadingAddPaymentMethod)
		);
	}

	onExit = () => {
		const { resetForm } = this.props;
		resetForm('addPayment');
	}

	onSubmit = (formData) => {
		const { addPaymentMethod, callback } = this.props;

		if (!formData.error) {
			addPaymentMethod(formData, callback);
		}
	}

	onPlaidSuccess = (token, metadata) => {
		const { addBankAccountWithPlaid, callback } = this.props;
		addBankAccountWithPlaid(token, metadata.account_id, callback);
	}

	render() {
		const {
			user, USStates, loadingUSStates, loadingAddPaymentMethod,
		} = this.props;

		const userAddress = {
			streetAddress : user.StreetAddress,
			city          : user.City,
			stateId       : user.StateId,
			zip           : user.Zip,
		};

		const plaidSettings = {
			env       : APP_ENV === 'production' ? APP_ENV : 'sandbox',
			publicKey : PLAID_KEY,
			onSuccess : this.onPlaidSuccess,
			onExit    : this.onExit,
		};

		return (
			<Fragment>
				<PaymentMethodsForm
					USStates={USStates}
					loadingUSStates={loadingUSStates}
					onSubmit={this.onSubmit}
					onCancel={this.onExit}
					userAddress={userAddress}
					plaidSettings={plaidSettings}
				/>
				<Loader active={loadingAddPaymentMethod} />
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	app : {
		user,
		USStates,
		loaders : {
			USStates         : loadingUSStates,
			addPaymentMethod : loadingAddPaymentMethod,
		},
	},
}) => ({
	user,
	USStates,
	loadingUSStates,
	loadingAddPaymentMethod,
});

const mapDispatchToProps = (dispatch) => ({
	...pick(bindActionCreators(Actions, dispatch), ['resetForm']),
	...pick(bindActionCreators(thunks, dispatch), ['addPaymentMethod', 'getUSStates', 'addBankAccountWithPlaid']),
});

AddPaymentMethod.propTypes = {
	USStates                : PropTypes.array,
	addBankAccountWithPlaid : PropTypes.func.isRequired,
	addPaymentMethod        : PropTypes.func.isRequired,
	getUSStates             : PropTypes.func.isRequired,
	loadingAddPaymentMethod : PropTypes.bool,
	loadingUSStates         : PropTypes.bool,
	resetForm               : PropTypes.func.isRequired,
	user                    : PropTypes.object,
	callback                : PropTypes.func,
};

AddPaymentMethod.defaultProps = {
	USStates                : [],
	loadingAddPaymentMethod : false,
	loadingUSStates         : false,
	user                    : {},
	callback                : undefined,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPaymentMethod);
